import { render, staticRenderFns } from "./email.vue?vue&type=template&id=2f98938b&scoped=true"
import script from "./email.vue?vue&type=script&lang=js"
export * from "./email.vue?vue&type=script&lang=js"
import style0 from "./email.vue?vue&type=style&index=0&id=2f98938b&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f98938b",
  null
  
)

export default component.exports